module.exports = __webpack_public_path__ + "static/snow-squat-aabc87b1d61105c18242662719e6dd8f.jpeg";